export default __webpack_public_path__ + "static/media/brackets3.e4dde0ea.png";